<template>
	<div >
		<div class="imgs_up" v-for="(el,index) in value" :key="index">
			<uploadImg :config="config" v-model="value[index]" ></uploadImg>
			<div v-if="index!=0" @click="del(index)" class="closeBox">✖</div>
		</div>
		
		<div class="tyod_btns_01" @click="add()">添加</div>
	</div>
	
</template>
 
<script>

import uploadImg from './uploadImg.vue';
export default {
	components:{uploadImg},
	props:{
		config:Object,
		value:Array
	},
	data(){
		return {

		}
	},
	methods:{
		add(){
			this.value.push('');
		},
		del(on){
			this.value.splice(on,1)
		}
	}
	
}
</script>
<style lang="scss">
.uplodImg_01{
	position: relative;
	cursor: pointer;
	width: 128px;
	height: 128px;
	background: #FAFAFA;
	border: 1px dashed #D9D9D9;
	box-sizing: border-box;
	border-radius: 2px;
	background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}
.uplodImg_02{
	display: block;
	margin: 41px auto 0;
}
.uplodImg_03{
	color: rgba(0, 0, 0, 0.45);
	margin: 13px auto 0;
	text-align: center;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;
}
.uplodImg_04{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	width: 80%;
}
.imgs_up{
	display: inline-block;
	vertical-align: top;
	position: relative;
}
.closeBox{
	position: absolute;
	right: 0;
	top: 0;
	width: 40px;
	height: 40px;
	text-align: center;
    line-height: 40px;
    font-size: 12px;
	cursor: pointer;
}
.tyod_btns_01{
display: inline-block;
    vertical-align: top;
    cursor: pointer;
    height: 30px;
    background: #33B3FF;
    border-radius: 5px;
    font-size: 12px;
    line-height: 30px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 50px;
    padding: 0 10px;
    margin-left: 20px;
}
.imgs_uptyp_01{
	width: 128px;
    padding-right: 34px;
    margin-bottom: 10px;
}
</style>	